export default "__VITE_ASSET__Mqd1S286__"